'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var FSM = require('fsm-event');

var multistream = require('multistream-select');

var withIs = require('class-is');

var BaseConnection = require('./base');

var IncomingConnectionFSM =
/*#__PURE__*/
function (_BaseConnection) {
  _inherits(IncomingConnectionFSM, _BaseConnection);

  function IncomingConnectionFSM(_ref) {
    var _this;

    var connection = _ref.connection,
        _switch = _ref._switch,
        transportKey = _ref.transportKey;

    _classCallCheck(this, IncomingConnectionFSM);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncomingConnectionFSM).call(this, {
      _switch: _switch,
      name: "inc:".concat(_switch._peerInfo.id.toB58String().slice(0, 8))
    }));
    _this.conn = connection;
    _this.theirPeerInfo = null;
    _this.ourPeerInfo = _this.switch._peerInfo;
    _this.transportKey = transportKey;
    _this.protocolMuxer = _this.switch.protocolMuxer(_this.transportKey);
    _this.msListener = new multistream.Listener();
    _this._state = FSM('DIALED', {
      DISCONNECTED: {
        disconnect: 'DISCONNECTED'
      },
      DIALED: {
        // Base connection to peer established
        privatize: 'PRIVATIZING',
        encrypt: 'ENCRYPTING'
      },
      PRIVATIZING: {
        // Protecting the base connection
        done: 'PRIVATIZED',
        disconnect: 'DISCONNECTING'
      },
      PRIVATIZED: {
        // Base connection is protected
        encrypt: 'ENCRYPTING'
      },
      ENCRYPTING: {
        // Encrypting the base connection
        done: 'ENCRYPTED',
        disconnect: 'DISCONNECTING'
      },
      ENCRYPTED: {
        // Upgrading could not happen, the connection is encrypted and waiting
        upgrade: 'UPGRADING',
        disconnect: 'DISCONNECTING'
      },
      UPGRADING: {
        // Attempting to upgrade the connection with muxers
        done: 'MUXED'
      },
      MUXED: {
        disconnect: 'DISCONNECTING'
      },
      DISCONNECTING: {
        // Shutting down the connection
        done: 'DISCONNECTED'
      }
    });

    _this._state.on('PRIVATIZING', function () {
      return _this._onPrivatizing();
    });

    _this._state.on('PRIVATIZED', function () {
      return _this._onPrivatized();
    });

    _this._state.on('ENCRYPTING', function () {
      return _this._onEncrypting();
    });

    _this._state.on('ENCRYPTED', function () {
      _this.log("successfully encrypted connection to ".concat(_this.theirB58Id || 'unknown peer'));

      _this.emit('encrypted', _this.conn);
    });

    _this._state.on('UPGRADING', function () {
      return _this._onUpgrading();
    });

    _this._state.on('MUXED', function () {
      _this.log("successfully muxed connection to ".concat(_this.theirB58Id || 'unknown peer'));

      _this.emit('muxed', _this.conn);
    });

    _this._state.on('DISCONNECTING', function () {
      if (_this.theirPeerInfo) {
        _this.theirPeerInfo.disconnect();
      }

      _this._state('done');
    });

    return _this;
  }
  /**
   * Attempts to encrypt `this.conn` with the Switch's crypto.
   *
   * @private
   * @fires IncomingConnectionFSM#error
   * @returns {void}
   */


  _createClass(IncomingConnectionFSM, [{
    key: "_onEncrypting",
    value: function _onEncrypting() {
      var _this2 = this;

      this.log("encrypting connection via ".concat(this.switch.crypto.tag));
      this.msListener.addHandler(this.switch.crypto.tag, function (protocol, _conn) {
        _this2.conn = _this2.switch.crypto.encrypt(_this2.ourPeerInfo.id, _conn, undefined, function (err) {
          if (err) {
            return _this2.close(err);
          }

          _this2.conn.getPeerInfo(function (_, peerInfo) {
            _this2.theirPeerInfo = peerInfo;

            _this2._state('done');
          });
        });
      }, null); // Start handling the connection

      this.msListener.handle(this.conn, function (err) {
        if (err) {
          _this2.emit('crypto handshaking failed', err);
        }
      });
    }
  }, {
    key: "_onUpgrading",
    value: function _onUpgrading() {
      this.log('adding the protocol muxer to the connection');
      this.protocolMuxer(this.conn, this.msListener);

      this._state('done');
    }
  }]);

  return IncomingConnectionFSM;
}(BaseConnection);

module.exports = withIs(IncomingConnectionFSM, {
  className: 'IncomingConnectionFSM',
  symbolName: 'libp2p-switch/IncomingConnectionFSM'
});